import { render, staticRenderFns } from "./heart-mailbox.vue?vue&type=template&id=158b3439&scoped=true"
import script from "./heart-mailbox.vue?vue&type=script&lang=js"
export * from "./heart-mailbox.vue?vue&type=script&lang=js"
import style0 from "./heart-mailbox.vue?vue&type=style&index=0&id=158b3439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b3439",
  null
  
)

export default component.exports